/// <amd-module name="DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Components/RestrictAllPipelinesConfirmationPanel" />
import * as React from "react";
import * as Resources from "DistributedTaskUI/SecurityComponent/Resources";
import { BuildDefinitionReference } from "DistributedTaskUI/SecurityComponent/PipelinePermissionsAuthorization/Source/Build/Contracts/Build";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Panel } from "VSSUI/Panel";
import { TitleSize } from "VSSUI/Header";
import { Table, TableColumnStyle, ITableColumn, SimpleTableCell } from "VSSUI/Table";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";

export interface IAuthorizeAllPipelinesConfirmationPanelProps {
    primaryOnClick: (restrict: boolean) => void;
    onDismiss: () => void;
    pipelineDefinitions: BuildDefinitionReference[];
}

export class RestrictAllPipelinesConfirmationPanel extends VssComponent< IAuthorizeAllPipelinesConfirmationPanelProps, {}> {
    constructor(props: IAuthorizeAllPipelinesConfirmationPanelProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): React.ReactNode {
        return (
            <Panel
                onDismiss={() => { this.props.onDismiss(); }}
                titleProps={{ text: Resources.RestrictAccessPanelTitle, size: TitleSize.Large }}
                footerButtonProps={[
                    { text: Resources.RestrictAccessPanelConfirmButton, primary: true, onClick: () => { this.props.primaryOnClick(true); } }
                ]}
                lightDismiss
            >
                <div>
                    <div>{ Resources.RestrictAccessPanelContecntLine1 }</div>
                    <div style={{ marginTop: "20px"}}>{ Resources.RestrictAccessPanelContecntLine2 }</div>
                    <Table
                        className="toggle-access-panel-pipelines-list"
                        itemProvider={new ArrayItemProvider(this.props.pipelineDefinitions)}
                        columns={[
                            {
                                id: "name",
                                width: -100,
                                name: Resources.PipelineString,
                                className: "pipeline-name-cell",
                                renderCell: this._renderNameCell,
                                columnStyle: TableColumnStyle.Primary
                            }
                        ]}
                        showHeader={false}
                    />
                </div>
            </Panel>
        );
    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: BuildDefinitionReference): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex}>
                <Icon className="pipeline-image" iconName="Rocket" role="presentation" />
                <span>
                    <Tooltip overflowOnly={true} text={tableItem.name}>
                        <span className="pipeline-name text-ellipsis">{tableItem.name}</span>
                    </Tooltip>
                    <span className="pipeline-type secondary-text body-s">
                        {Resources.PipelineString}
                    </span>
                </span>
            </SimpleTableCell>
        );
    }
}
